export class FunctionLogger {
    logs;
    static instance;
    functionName;
    isLogging;
    startTime;
    previousTime;
    constructor(functionName) {
        this.functionName = functionName;
        this.logs = [];
        this.isLogging = true;
        this.startTime = Date.now();
        this.previousTime = this.startTime;
    }
    static log(message, includeTime) {
        if (this.instance?.isLogging) {
            const now = Date.now();
            const logObj = { time: new Date(now), message };
            if (includeTime) {
                logObj.accumulatedTime = now - this.instance.startTime;
                logObj.differenceIntime = now - this.instance.previousTime;
                this.instance.previousTime = now;
            }
            this.instance.logs.push(logObj);
        }
    }
    static startLogging(functionName) {
        this.instance = new FunctionLogger(functionName);
    }
    static endLogging() {
        if (this.instance) {
            this.instance.isLogging = false;
        }
    }
    static getLogs() {
        if (this.instance) {
            return {
                functionName: this.instance.functionName,
                logs: this.instance.logs,
            };
        }
    }
}
//# sourceMappingURL=function-logger.js.map